export default __webpack_public_path__ + "static/media/5.308a0205.jpg";